import {
  getAddressAutosuggest as getAddressAutosuggestApi,
  getAddressDetail as getAddressDetailApi,
} from "@/api/search";
import orderBy from "lodash/orderBy";
import { combiningStrings } from "@/tools/basic-methods";
const state = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getAddressSearch({ rootState }, { value }) {
      let api = getAddressAutosuggestApi;
      let { latitude: lat, longitude: lon } = rootState.inUseLocation;
      let params = { input: value, lat, lon };
      return api(params).then(
        (result) => {
          try {
            let data = result.res.data.data.map((item) => {
              item.value = item.title;
              item.unifiedTitle = item.highlightedTitle || item.title;
              item.pointType = item.isFacility ? "facility" : "address";
              item.latitude = item.position[0];
              item.longitude = item.position[1];
              item.facilityId = item.facilityId || null;
              return item;
            });
            return orderBy(data.slice(0, 5), ["isFacility", "asc"]);
          } catch (error) {
            return [];
          }
        },
        () => {
          return [];
        }
      );
    },
    getAddressDetail(context, info) {
      let params = {
        context: info.context,
        id: info.id,
      };
      return getAddressDetailApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            let bbox = data.bbox;
            let category = data.category;
            let title = data.name;
            let location = data.location;
            let position = location.position;
            let latitude = position[0];
            let longitude = position[1];
            let address = location.address;
            let postalCode = address.postalCode;
            let city = address.city;
            let country = address.country;
            let countryCode = address.countryCode;
            let county = address.county;
            let state = address.state;
            let stateCode = address.stateCode;
            let locationInfo = combiningStrings([
              city,
              stateCode,
              postalCode,
              countryCode,
            ]);
            let resultInfo = {
              bbox,
              category,
              latitude,
              longitude,
              postalCode,
              city,
              country,
              title,
              countryCode,
              county,
              state,
              stateCode,
              locationInfo,
              pointType: "address",
              info: data,
            };
            return resultInfo;
          } catch (error) {
            console.log(error);
            return null;
          }
        },
        (error) => {
          console.log(error);
          return null;
        }
      );
    },
  },
  getters: {},
};

export default state;
